export enum ArticleStatus {
  AwaitingApproval,
  Approved,
}
